import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import MuiLink from '@mui/material/Link';
import GenericPopover from "./genericpopover";

const ExplainerCard = ({ 
  description, 
  instructions, 
  howItWorks,
  instructionsLabel = "Instructions",
  howItWorksLabel = "How It Works",
  instructionsMaxWidth = "400px",
  instructionsMinWidth = "320px",
  howItWorksMaxWidth = "400px",
  howItWorksMinWidth = "320px"
}) => {
  const instructionsTrigger = (
    <MuiLink 
      component="button" 
      variant="body2" 
      underline="hover"
      style={{ cursor: 'pointer', fontWeight: 500 }}
    >
      {instructionsLabel}
    </MuiLink>
  );
  
  const howItWorksTrigger = (
    <MuiLink 
      component="button" 
      variant="body2" 
      underline="hover"
      style={{ cursor: 'pointer', fontWeight: 500 }}
    >
        {howItWorksLabel}
    </MuiLink>
  );
  
  return (
    <Card>
      <CardContent className="font-light" style={{ padding: '16px 20px' }}>
        <div style={{ margin: '0 0 12px 0', lineHeight: '1.6' }}>
          {description}
        </div>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
          {instructions && (
            <GenericPopover 
              triggerElement={instructionsTrigger}
              maxWidth={instructionsMaxWidth}
              minWidth={instructionsMinWidth}
            >
              <div className="font-light">
                {instructions}
              </div>
            </GenericPopover>
          )}
          
          {howItWorks && (
            <GenericPopover 
              triggerElement={howItWorksTrigger}
              maxWidth={howItWorksMaxWidth}
              minWidth={howItWorksMinWidth}
            >
              <div className="font-light">
                {howItWorks}
              </div>
            </GenericPopover>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default ExplainerCard;
